import {
  Paragraph as HeaderDescription,
  Typography as HeaderTitle,
} from '@tmov/design-system';
import PropTypes from 'prop-types';
import React from 'react';

export function DrawerHeader({ headerTitle, headerDescription }) {
  const descriptionProps = {
    variant: 'p1',
    style: {
      color: '#6D787D',
    },
  };

  return (
    <>
      <HeaderTitle variant="h4">{headerTitle}</HeaderTitle>
      <HeaderDescription {...descriptionProps}>
        {headerDescription}
      </HeaderDescription>
    </>
  );
}

DrawerHeader.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  headerDescription: PropTypes.node.isRequired,
};
